<template>
  <header>
    <h4 class="text-center">
      Your Referral Link
    </h4>
    <p class="text-center text-gray mt-sm">
      Share your unique link or tell your friends to enter code
      <span class="current-code">{{ referralCode }}</span> at checkout.
    </p>
  </header>
</template>

<script setup>
defineProps({
  referralCode: {
    type: String,
    required: true
  }
})
</script>

<style lang="scss" scoped>
  .current-code {
    color: $plum;
    font-weight: $font-weight-semibold;
  }
</style>
